import { useEffect, useState } from "react";

import { Helmet } from "react-helmet-async";
import { useSearchParams, useNavigate } from "react-router-dom";
import Loading from "../SpinnerAndError/Loading";
import { Alert } from "antd";
import { Container, Row, Col } from "antd";
import { Spin } from "antd";

const OrderSuccessfullPage = () => {
  const [customerName, setCustomerName] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [message, setMessage] = useState("");
  const token = window.localStorage.getItem("token");
  const token2 = token?.slice(1, -1);
  const [searchParams] = useSearchParams();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  let navigate = useNavigate();

  useEffect(() => {
    fetchDataOnMount();
  }, []);

  const fetchDataOnMount = async () => {
    const session_id = searchParams.get("session_id");

    try {
      const response = await fetch(
        process.env.REACT_APP_STRIPE_SUCCESSFULL_PAYMENT +
          "?" +
          "session_id" +
          "=" +
          session_id,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setSuccessMessage(data.message);
          setTimeout(() => {
            navigate("/");
          }, 7000);
        } else {
          setErrorMessage(data.error);
        }
      }
    } catch (error) {
      console.log(error);
      setErrorMessage("Something went wrong. Please try again later.");
    }
  };

  return (
    <>
      <Row
        justify="center"
        align="middle"
        style={{ minHeight: "100vh", alignSelf: "center" }}
      >
        <Col xs={24} sm={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            {successMessage && (
              <Alert
                message={successMessage}
                type="success"
                showIcon
                style={{ marginBottom: 16 }}
              />
            )}
            {errorMessage && (
              <Alert
                message={errorMessage}
                type="error"
                showIcon
                style={{ marginBottom: 16 }}
              />
            )}
            {!successMessage && !errorMessage && (
              <div
                style={{ display: "flex", justifyContent: "center", flex: 1 }}
              >
                <Spin size="large" />
              </div>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default OrderSuccessfullPage;
